module.exports = __webpack_public_path__ + "img/Ghost.2ff05388.svg";